/**
 * Every URL once. Route definitions, links and redirects reference these.
 */
export const paths = {
  home: { path: '/' },
  in: { path: '/in' },
  privacy: { path: '/privacy' },
  qr: { path: '/qr' },
  shipping: { path: '/shipping' },
  team: { path: '/team' },
} as const;
